import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newtonIAConfig } from "./data";

export default function NewtonIAPage() {
  return <CityPageTemplate config={newtonIAConfig} />;
}